export const toVectorLength = (v: number[]): number => {
	return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
};
